export const ROUTE_PATHS = {
  ERROR_HANDLING: '/test-error-handling',
  TOAST_DEMO: '/toast-demo',
  LOGIN: '/login',
  SILENT_SSO_CALLBACK: '/silent-check-sso',
  FORGOT_PASSWORD: '/forgot-password', // NOSONAR
  RESET_PASSWORD: '/reset-password', // NOSONAR
  OTP_VERIFICATION: '/otp-verification',
  SSO_OTP_VERIFICATION: '/sso-otp-verification',
  SSO_ERROR: '/sso-error',
  TERMS_AND_CONDITIONS: '/terms-and-conditions',
  HOME: '/',
  CATEGORY_HOME: '/category-home-page',
  SUPPORT: '/support',
  PRIVATE_BANKING: '/private-banking',
  PRIVATE_BANKING_REPORT: '/private-banking-report/:bankDomicile/:countryManualId',
  LEI_HOME_PAGE: '/:productName/lei/:renderingStyleId',
  LEI_OUT_COME_PAGE: '/:productName/lei-outcome/:leiCode',
  LEI_NETTING_ANALYSIS_PAGE: '/:productName/lei-netting-analysis/:counterpartyCode',
  CHANGE_PASSWORD: '/change-password', // NOSONAR
  FIND_GRIDS: '/find-grids',
  VIEW_GRID: '/grid/view',
  CONTENT_TILE_VIEW_GRID: '/grid/content-tile-view',
  EDIT_GRID: '/grid/edit',
  GRID_SETTINGS: '/grid/settings',
  VIEW_GRID_FILTER: '/grid/filter',
  DRAFT_GRIDS: '/draft-grids',
  ARCHIVED_GRIDS: '/archived-grids',
  PREVIEW_PAGES: '/preview-pages',
  PREVIEW_PAGE: '/preview-pages', // adding duplicate key because of PREVIEW_PAGE is come from shared-url api response 
  FIND_PAGES: '/find-pages',
  DRAFT_PAGES: '/draft-pages',
  ARCHIVED_PAGES: '/archived-pages',
  FIND_REPORTS: '/find-reports',
  GUEST_USER_REPORTS: '/guest-user-reports',
  ADD_NEW_REPORT: '/add-new-report-select-product',
  ADD_NEW_REPORT_ONLY_PART1: '/add-new-report-only-part1',
  BOOKMARKED_REPORT: '/bookmarked',
  RECENT_VIEWED: '/recent-viewed',
  RECENT_UPDATES: '/recent-updates',
  OPINION_DRAFT: '/draft-reports',
  OPINION_ARCHIVED: '/archived-reports',
  PRODUCT: '/product',
  API_PRODUCT: '/report-api',
  PRODUCT_REDIRECT: '/product-redirect/:productId',
  MY_ALERT: '/my-alert',
  REPORT_SINGLE: '/report-single',
  OPINION_ADD: '/edit-report',
  EDIT_PAGE: '/edit-page/*',
  OPINION_COMPARE: '/opinion-compare',
  OPINION_COMPARE_TAB: '/opinion-compare-tab',
  ALL_ALERTS: '/all-alerts',
  ADD_ALERT: '/add-new-alert',
  EDITORIAL_PAGE: '/editorial-page',
  VERSION_HISTORY: '/version-history',
  REPORTING: '/reporting',
  REPORT_MULTITEMPLATE: '/report-multi-template',
  REPORT_TAB: '/report-tab',
  REPORT_VIEW_COMPARE: '/report-view-compare',
  REPORT_ONLY_CHANGES: '/report-only-changes',
  REPORT_VERSION_COMPARISON:"/report-version-comparison",
  REPORT_VIEW:"/report-view",
  MY_REVIEWS: '/my-reviews',
  PAGE_VERSION_HISTORY: '/page-version-history',
  STANDARD_ERROR: '/standard-error',
  ACCESS_ERROR: '/access-error',
  PUBLIC_STANDARD_ERROR: '/public-standard-error',
  PUBLIC_ACCESS_ERROR: '/public-access-error',
  GRID_VERSION_HISTORY: "/grid-version-history",
  GRID_VIEW: "/grid-view",
  CK_EDITOR:"/ckeditor",
  RICH_TEXT_BOX_POPUP: "/rich-text-box-popup",
  ADD_INTERNAL_NOTE:"/add-internal-note",
  PAGE_VERSION_COMPARISION: "/page-version-comparision",
  CK_EDITOR_DEFINITION_PLUGIN: "/ckeditor/definition-plugin",
  CK_EDITOR_REPORT_DEFINITION_PLUGIN: "/ckeditor/report-definition-plugin",
  CK_EDITOR_DOCUMENT_LINK_PLUGIN: "/ckeditor/document-link-plugin",
  CK_EDITOR_PAGE_DOCUMENT_LINK_PLUGIN: "/ckeditor/page-document-link-plugin",
  CK_EDITOR_DOCUMENT_PDF_PAGE_DOWNLOAD: "/pdf-page-download",
  ALERT_DOC_DOWNLOAD: "/alert-docdownload",
  CONDITION_OF_USE_DOC_DOWNLOAD: "/condition-of-use-docdownload",
  DOWNLOAD_RESOURCE: "/download-resource",
  CK_EDITOR_DOCUMENT_DEFINITION_ALERT_PLUGIN: "/ckeditor/document-definition-alert-plugin",
  CK_EDITOR_ALERT_DOCUMENT_LINK_PLUGIN: "/ckeditor/alert-document-link-plugin",
  CK_EDITOR_GRID_DEFINITION_PLUGIN: "/ckeditor/grid-definition-plugin",
  CK_EDITOR_GRID_DOCUMENT_LINK_PLUGIN: "/ckeditor/grid-document-link-plugin",


  // Additional routes for CFM URL replacements
  CK_EDITOR_VIEW_DOCUMENT: "/ckeditor/view-document",
  VIEW_DOCUMENT: "/view-document",
  CK_EDITOR_IMAGE_BROWSER: "/ckeditor/image-browser",
  ADVANCED_SEARCH: "/advanced-search",
  SEARCH_DOC_DOWNLOAD: "/search-docdownload",
  SOURCE_DOC_DOWNLOAD: "/source-docdownload",
  PRIVATE_BANKING_DOC_DOWNLOAD: "/private-banking-docdownload",
  INTERNAL_NOTES_ATTACHMENT: "/internal-notes-attachment",

  // links open in new tab
  PAGE_VIEW_LINK: '/page-view-link',
  REPORT_VIEW_LINK: '/report-view-link',
  GRID_VIEW_LINK:'/grid-view-link',
  PDF_VIEWER: '/pdf-viewer',
  DOWNLOAD_SUCCESS: '/download-success',

  /** Site-root 404 path for navigate/replace; same UI as splat `NOT_FOUND` (no extra Route). */
  NOT_FOUND_PAGE: '/not-found',
  PAGE_MOVED: '/page-moved',
  HANDLE_CFM_LINKS: '/handle-cfm-links',
  
  LOGOUT: '/logout',

  NOT_FOUND: '*',
};

export const V3_ROUTE_PATHS = {
  DASHBOARD: '/dashboard',
};